class MobileProductPreview extends window.BAO.CustomElement() {
  connectedCallback () {
    this.updateProductPreviewHeight()

    window.addEventListener('resize', this.updateProductPreviewHeight.bind(this))
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    window.removeEventListener('resize', this.updateProductPreviewHeight.bind(this))
  }

  updateProductPreviewHeight () {
    const width = window.innerWidth
    let height = this.els.preview.element.offsetHeight + 30 || 100

    if (this.externalEls?.aboveHeader?.element) {
      height += this.externalEls.aboveHeader.element.offsetHeight
    }

    if (width < 1000) {
      document.body.style.setProperty('--product-preview-height', `${height}px`)
    } else {
      document.body.style.removeProperty('--product-preview-height')
    }
  }
}

if (!customElements.get('mobile-product-preview')) {
  customElements.define('mobile-product-preview', MobileProductPreview)
}

// move into product-media to work out height before carousel
